import { isAfter } from 'date-fns';
import { SpecializedSupport, SpecializedSupportDisplay } from '@sondermind/constants';
import { ProviderUser } from '@sondermind/utilities/models-user-provider';

export const generateExperienceSupportingList = (
  ages: string[] = [],
  servicesOffered: string[] = [],
  specialties: string[] = []
): string[] => {
  const specializedSupportList: string[] = [];
  // The following if statements are used to set order of specialized topics
  if (ages.find((age) => age === SpecializedSupport.INFANTS || age === SpecializedSupport.CHILDREN)) {
    specializedSupportList.push(SpecializedSupportDisplay.INFANTS);
  }

  if (ages.includes(SpecializedSupport.ADOLESCENTS)) {
    specializedSupportList.push(SpecializedSupportDisplay.ADOLESCENTS);
  }

  if (ages.includes(SpecializedSupport.ADULTS)) {
    specializedSupportList.push(SpecializedSupportDisplay.ADULTS);
  }

  if (ages.includes(SpecializedSupport.SENIORS)) {
    specializedSupportList.push(SpecializedSupportDisplay.SENIORS);
  }

  if (servicesOffered.includes(SpecializedSupport.COUPLES)) {
    specializedSupportList.push(SpecializedSupportDisplay.COUPLES);
  }

  if (specialties.find((spec) => spec === SpecializedSupport.LGBTQIA)) {
    specializedSupportList.push(SpecializedSupportDisplay.LGBTQIA);
  }

  if (specialties.find((spec) => spec === SpecializedSupport.VETERAN)) {
    specializedSupportList.push(SpecializedSupportDisplay.VETERAN);
  }

  if (specialties.find((spec) => spec === SpecializedSupport.PERINATAL)) {
    specializedSupportList.push(SpecializedSupportDisplay.PERINATAL);
  }
  return specializedSupportList;
};

/** Returns the first letter of the first and last name */
export function getInitials(firstName: string | undefined | null, lastName: string | undefined | null): string {
  // Cast first and last to empty string if they happen to be null or undefined
  const first = firstName || '';
  const last = lastName || '';
  return `${first.trim().charAt(0)}${last.trim().charAt(0)}`.toUpperCase();
}

export function checkProviderCreationBeforeCutoffDate(
  cutoffDate: string,
  user: ProviderUser
): boolean {
  const schedulingProfileCreatedAt = user?.schedulingProfile?.createdAt;
  if (schedulingProfileCreatedAt && cutoffDate) {
    return isAfter(new Date(schedulingProfileCreatedAt), new Date(cutoffDate));
  }
  return false;
}
